import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import { MenuItem, FormHelperText, FormControl, Select } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import { CSSProperties } from 'styled-components'

type DropdownProps = {
    onChange?: (event: DropdownChangeEvent) => void
    onBlur?: () => void
    onFocus?: () => void
    onClear?: () => void
    options: DropdownDataType[]
    label?: string
    placeholder?: string
    value?: string | number
    disabled?: boolean
    required?: boolean | string
    fullWidth?: boolean
    helperText?: string
    input?: any
    meta?: any
    customStyle?: CSSProperties
    text?: string
}

const DropdownControl = (props: DropdownProps) => {
    const {
        onChange,
        onBlur,
        onFocus,
        onClear,
        options,
        label,
        placeholder,
        value,
        disabled = false,
        required = false,
        helperText,
        fullWidth,
        meta,
        customStyle = {}
    } = props
    const { t } = useTranslation()
    const classes = useStyles()
    const isError = meta?.error && meta?.invalid && meta?.touched ? true : false
    const isRequired = (typeof required === 'string') ? (required === 'Required') : required

    return (
        <FormControl variant="outlined" fullWidth={fullWidth} error={isError}>
            <Typography>
                {label} {!disabled && isRequired && <label style={{ color: '#d32f2f' }}>{' *'}</label>}
            </Typography>
            <Select
                displayEmpty={placeholder ? true : false}
                onFocus={onFocus}
                onBlur={onBlur}
                value={value}
                required={!disabled && isError}
                disabled={disabled}
                onChange={(event: any) => {
                    onChange && onChange(event.target.value)
                }}
                className={clsx(classes.label, { [classes.disabledField]: disabled })}
                style={customStyle}
                defaultValue=""
                size="small"
            >
                {placeholder && (
                    <MenuItem disabled value="">
                        <em>{placeholder}</em>
                    </MenuItem>
                )}
                {options.map((item: DropdownDataType, index: number) => (
                    <MenuItem key={`dropdown-${index}`} value={item.value}>
                        {item.label}
                    </MenuItem>
                ))}
            </Select>
            <FormHelperText>
                <label style={{ color: '#d32f2f' }}>
                    {!disabled
                        ? isError && meta.error
                            ? helperText
                                ? helperText
                                : t('LABEL.SELECT_REQUIRED')
                            : ''
                        : ''}
                </label>
            </FormHelperText>
        </FormControl>
    )
}

export default DropdownControl

const useStyles = makeStyles((theme: Theme) => ({
    label: {
        height: '40px',
        backgroundColor: 'white',
    },
    disabledField: {
        backgroundColor: theme.palette.getContrastText('bg-backoffice'),
    },
}))
